module.exports = __webpack_public_path__ + "img/campus-live-seminar.dd6d2e1b.svg";